// 依頼
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex/store.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import baseHttp from '@/assets/js/base_http.js'
import Lockr from 'lockr'
import config from '@/assets/js/config.js'
import _g from '@/assets/js/global.js'
import http from '../assets/js/http'

// 社内向け夜間産廃搬入状況確認ログイン画面
import CompanyLogin from '@/components/shanaikanrisha/login.vue'
// 社内向けパスワード変更／確認機能
import ChangePwd from '@/components/shanaikanrisha/changePwd.vue'
// 社内向け 予約状況一覧表示
import AdminDayList from '@/components/shanaikanrisha/dayList.vue'
// 社内向け夜間産廃搬入状況確認機能
import adminSearch from '@/components/shanaikanrisha/search.vue'
// 社内向け 会社別搬入情報一覧(会社毎・日付毎・時刻毎の一覧表)
import InsideCompany from '@/components/shanaikanrisha/companyList.vue'
// 社内向け 指定日搬入時間単位搬入品目件数状況
import ClientList from '@/components/shanaikanrisha/clientList.vue'
// 社内向け 取引先一覧
import itemList from '@/components/shanaikanrisha/itemList.vue'
// 社内向け 当日搬入時間単位搬入品目件数状況
import todayItemList from '@/components/shanaikanrisha/todayItemList.vue'
// 社内向け 当日搬入時間単位予約トラック台数状況
import todayTruckList from '@/components/shanaikanrisha/todayTruckList.vue'
// 社内向け 指定日搬入時間単位予約トラック台数状況
import truckList from '@/components/shanaikanrisha/truckList.vue'
// 夜間産廃搬入申込サービスログイン画面
import Login from '@/components/customer/login.vue'
// 取引先公開 夜間産廃搬入状況確認
import customerSearch from '@/components/customer/search.vue'
// 取引先公開 予約状況一覧表示
import dayList from '@/components/customer/dayList.vue'
// 取引先向 会社別搬入情報一覧(会社毎・日付毎・時刻毎の一覧表)
import CustomerCompany from '@/components/customer/companyList.vue'
// 夜間産廃搬入情報入力 1/4
import JouHouNyuuRyoKu from '@/components/customer/informationInput.vue'
// 夜間産廃搬入情報入力 2/4
import JouHouNyuuRyoKuDetail from '@/components/customer/informationInputDetail.vue'
// 夜間産廃搬入予約番号表示
import JouHouNyuuRyoKuShow from '@/components/customer/informationInputShow.vue'
// ログイン画面（台貫）
import DaikanLogin from '@/components/daikan/login.vue'
// 社内向け 会社別搬入情報一覧(会社毎・日付毎・時刻毎の一覧表)（台貫）
import daikanCompany from '@/components/daikan/companyList.vue'
Vue.use(VueRouter)

const routes = [
  { path: '/', component: Login, name: 'Login' },
  { path: '/customer/login', component: Login, name: 'Login' },
  { path: '/shanaikanrisha/login', component: CompanyLogin, name: 'CompanyLogin' },
  { path: '/daikan/login', component: DaikanLogin, name: 'DaikanLogin' },
  {
    path: '/shanaikanrisha/changePwd',
    component: ChangePwd,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/changePwd', component: ChangePwd, name: 'ChangePwd', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/clientList',
    component: ClientList,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
      { path: 'shanaikanrisha/clientList', component: ClientList, name: 'ClientList', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/companyList',
    component: InsideCompany,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/companyList', component: InsideCompany, name: 'InsideCompany', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/itemList',
    component: itemList,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/itemList', component: itemList, name: 'itemList', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/todayItemList',
    component: todayItemList,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/todayItemList', component: todayItemList, name: 'todayItemList', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/todayTruckList',
    component: todayTruckList,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/todayTruckList', component: todayTruckList, name: 'todayTruckList', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/truckList',
    component: truckList,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/truckList', component: truckList, name: 'truckList', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/dayList',
    component: AdminDayList,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/dayList', component: AdminDayList, name: 'AdminDayList', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/shanaikanrisha/search',
    component: adminSearch,
    meta: { requireAuth: true, routerFlg: 1 },
    children: [
            { path: 'shanaikanrisha/search', component: adminSearch, name: 'adminSearch', meta: { requireAuth: true, routerFlg: 1 }}
    ]
  },
  {
    path: '/customer/search',
    component: customerSearch,
    meta: { requireAuth: true, routerFlg: 0 },
    children: [
            { path: 'customer/search', component: customerSearch, name: 'customerSearch', meta: { requireAuth: true, routerFlg: 0 }}
    ]
  },
  {
    path: '/customer/dayList',
    component: dayList,
    meta: { requireAuth: true, routerFlg: 0 },
    children: [
            { path: 'customer/dayList', component: dayList, name: 'dayList', meta: { requireAuth: true, routerFlg: 0 }}
    ]
  },
  {
    path: '/customer/companyList',
    component: CustomerCompany,
    meta: { requireAuth: true, routerFlg: 0 },
    children: [
            { path: 'customer/companyList', component: CustomerCompany, name: 'CustomerCompany', meta: { requireAuth: true, routerFlg: 0 }}
    ]
  },
  {
    path: '/customer/informationInput',
    component: JouHouNyuuRyoKu,
    meta: { requireAuth: true, routerFlg: 0 },
    children: [
            { path: 'customer/informationInput', component: JouHouNyuuRyoKu, name: 'JouHouNyuuRyoKu', meta: { requireAuth: true, routerFlg: 0 }}
    ]
  },
  {
    path: '/customer/informationInputDetail',
    component: JouHouNyuuRyoKuDetail,
    meta: { requireAuth: true, routerFlg: 0 },
    children: [
            { path: 'customer/informationInputDetail', component: JouHouNyuuRyoKuDetail, name: 'JouHouNyuuRyoKuDetail', meta: { requireAuth: true, routerFlg: 0 }}
    ]
  },
  {
    path: '/customer/informationInputShow',
    component: JouHouNyuuRyoKuShow,
    meta: { requireAuth: true, routerFlg: 0 },
    children: [
            { path: 'customer/informationInputShow', component: JouHouNyuuRyoKuShow, name: 'JouHouNyuuRyoKuShow', meta: { requireAuth: true, routerFlg: 0 }}
    ]
  },
  {
    path: '/daikan/companyList',
    component: daikanCompany,
    meta: { requireAuth: true, routerFlg: 2 },
    children: [
      { path: 'daikan/companyList', component: daikanCompany, name: 'daikanCompany', meta: { requireAuth: true, routerFlg: 2 }}
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
})
router.beforeEach((to, from, next) => {
  var loginRoot = window.localStorage.getItem('loginRoot')
  let data = {}
  data.userId = loginRoot
  const requireAuth = to.meta.requireAuth
  const routerFlg = to.meta.routerFlg
  if (to.name === 'CompanyLogin' || to.name === 'Login' || to.name === 'DaikanLogin') {
    next()
  }
  if (requireAuth) {
    if (loginRoot !== '') {
      if (routerFlg === 1) {
        baseHttp.apiPost('shanaikanrisha/Login/isLogin', data).then((res) => {
          if (res.code != 200) {
            _g.toastMsg('warning', res.error)
            router.replace('/shanaikanrisha/login')
            return
          } else {
            next()
          }
        })
      } else if (routerFlg === 0) {
        baseHttp.apiPost('customer/Login/isLogin', data).then((res) => {
          if (res.code != 200) {
            _g.toastMsg('warning', res.error)
            router.replace('/customer/login')
            return
          } else {
            next()
          }
        })
      } else if (routerFlg === 2) {
        baseHttp.apiPost('daikan/Login/isLogin', data).then((res) => {
          if (res.code != 200) {
            _g.toastMsg('warning', res.error)
            router.replace('/daikan/login')
            return
          } else {
            next()
          }
        })
      } else {
        next()
      }
    } else {
            // next('/')
      _g.toastMsg('warning', 'ログインしてください。')
      setTimeout(() => {
        if (routerFlg === 1) {
          router.replace('/shanaikanrisha/login')
        } else if (routerFlg === 0) {
          router.replace('/customer/login')
        } else {
          router.replace('/daikan/login')
        }
      }, 1500)
    }
  }
})

router.afterEach(transition => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js